import { useLang } from "@/context/LanguageContext";
import Reveal from "./Reveal";

export default function Process() {
  const { t } = useLang();
  const steps = t("process.steps");
  return (
    <section id="process" className="py-20 md:py-28 bg-white" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal className="max-w-2xl">
          <span className="text-sm font-bold uppercase tracking-[0.18em] text-ksy-blue">{t("process.label")}</span>
          <h2 className="mt-3 font-display font-extrabold text-3xl md:text-4xl text-ksy-navy tracking-tight">{t("process.title")}</h2>
          <p className="mt-3 text-lg text-slate-500">{t("process.subtitle")}</p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-4 gap-8 md:gap-6 relative">
          <div className="hidden md:block absolute top-7 left-[12%] right-[12%] h-px bg-slate-200" />
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1} testid={`process-step-${s.n}`}>
              <div className="relative">
                <span className="relative z-10 grid place-items-center w-14 h-14 rounded-full bg-ksy-navy text-white font-display font-extrabold text-lg mb-5 ring-8 ring-white">
                  {s.n}
                </span>
                <h3 className="font-display font-bold text-lg text-ksy-navy">{s.t}</h3>
                <p className="mt-2 text-slate-500 leading-relaxed">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
